import { Opportunity } from "@/opportunity/opportunity";
import { Card } from "@/components/ui/card";
import { DatumCard } from "@/components/datum-card";

const OpportunitySavingsCard = ({ opportunity }: { opportunity: Opportunity }) => {

  if (!opportunity.savings || opportunity.savings.every((saving) => saving.value === 0)) {
    return;
  }

  const savingsNameExpansion: Record<string, string> = {
    "FRP": "Fuel reduction potential",
    "ERP": "Emissions reduction potential",
  }

  return (
    <Card className="p-4">
      <h3 className="text-xl font-barlow font-semibold text-gray-800 mb-4">
        Potential savings
      </h3>
      <div className="flex flex-col lg:flex-row gap-2">
        {
          opportunity.savings
            .filter(
              (saving) => saving.value !== 0
            )
            .sort(
              (saving1, saving2) => (saving1.name > saving2.name) ? 1 : -1
            )
            .map((saving, index) => (
                <DatumCard
                  key={index}
                  datum={saving.value}
                  suffix={saving.unit}
                  title={savingsNameExpansion[saving.name] || saving.name}
                />
              )
            )
        }
      </div>
    </Card>
  );
};

export default OpportunitySavingsCard;
